"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddButtonV2Styles = void 0;
const styles_1 = require("@mui/material/styles");
const useAddButtonV2Styles = ({ elevated }) => {
    const theme = (0, styles_1.useTheme)();
    const root = {
        width: '28px',
        height: '28px',
        padding: 0,
        backgroundColor: 'white',
        borderRadius: '0.25rem',
        borderColor: theme.qlub.palette.black.focus,
        boxShadow: elevated ? '0px 2px 8px rgba(0, 0, 0, 0.15)' : 'none',
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: elevated ? '0px 4px 12px rgba(0, 0, 0, 0.2)' : 'none',
        },
        '&:disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
        },
    };
    const icon = {
        fontSize: 21,
        color: theme.palette.common.black,
        '.Mui-disabled &': {
            color: theme.palette.action.disabled,
        },
        'html[dir="rtl"] &': {
            transform: 'scaleX(-1)',
        },
    };
    const quantity = {
        fontSize: '14px',
        fontWeight: 'bold',
        color: theme.palette.common.black,
        '.Mui-disabled &': {
            color: theme.palette.action.disabled,
        },
    };
    return { root, icon, quantity };
};
exports.useAddButtonV2Styles = useAddButtonV2Styles;
